import React, { MouseEventHandler } from "react"
import { Button, Col, Modal, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"

const ConfirmModal = ({
    show,
    data,
    handleClose,
    handleSubmit,
    title,
    loading = false
}: {
    show: string
    data: any
    handleClose: () => void
    handleSubmit: Function
    title: string
    loading?: boolean
}) => {
    const { t } = useTranslation()

    return (
        <Modal
            show={["cancelConfirmModal", "deleteConfirmModal", "splitConfirmModal"].includes(show)}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName={"gray-bg"}
            centered>
            <Modal.Header className="mx-2" closeButton>
                <Modal.Title>{t(title)}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-4 mb40 mt-3 py-0">
                <Row className="d-flex align-items-center justify-content-center pt-2 pb-4">
                    <p className="mb-4">{t("Are you sure you want to continue, this cannot be undone!")}</p>
                    <Col lg={4} className="d-flex align-items-center justify-content-center">
                        <Button
                            variant="secondary"
                            className="w-100"
                            onClick={handleClose as MouseEventHandler<HTMLButtonElement>}>
                            {t("No")}
                        </Button>
                    </Col>
                    <Col lg={4} className="d-flex align-items-center justify-content-center">
                        <Button
                            onClick={() => {
                                handleSubmit(data)
                                handleClose()
                            }}
                            disabled={loading}
                            className="btn btn-primary w-100"
                            type="submit">
                            {loading ? (
                                <div className="spinner-border text-light" role="submit"></div>
                            ) : (
                                t("Yes")
                            )}
                        </Button>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
}

export default ConfirmModal
